import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { adminApi, setToken } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      toast.error("Bitte E-Mail und Passwort eingeben");
      return;
    }
    setLoading(true);
    try {
      const { data } = await adminApi.post("/admin/login", { email, password });
      setToken(data.access_token);
      toast.success("Eingeloggt — willkommen zurück!");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login fehlgeschlagen";
      toast.error(typeof msg === "string" ? msg : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen flex items-center justify-center px-5 py-16 bg-[#F4F4F0]"
    >
      <div className="w-full max-w-md">
        <p className="font-mono-acc text-xs text-[#525252] mb-3">// Admin</p>
        <h1 className="font-display uppercase text-5xl md:text-6xl leading-[0.9] mb-8">
          Ein<span className="text-[#FF3B00]">loggen.</span>
        </h1>

        <form
          onSubmit={onSubmit}
          noValidate
          data-testid="admin-login-form"
          className="bg-white border-2 border-black shadow-brutal p-6 md:p-8 space-y-5"
        >
          <div>
            <label htmlFor="admin-email" className="font-mono-acc text-[11px] block mb-2">
              E-Mail
            </label>
            <input
              id="admin-email"
              type="email"
              data-testid="admin-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 bg-[#F4F4F0] border-2 border-black focus:outline-none focus:bg-[#FFF6F2]"
              placeholder="sude.dilara@outlook.de"
              autoComplete="email"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="font-mono-acc text-[11px] block mb-2">
              Passwort
            </label>
            <input
              id="admin-password"
              type="password"
              data-testid="admin-password-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-[#F4F4F0] border-2 border-black focus:outline-none focus:bg-[#FFF6F2]"
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#FF3B00] text-white border-2 border-black shadow-brutal hover:translate-y-[2px] hover:shadow-brutal-press transition-all font-mono-acc text-xs disabled:opacity-60"
          >
            <Lock className="w-4 h-4" />
            {loading ? "Logge ein…" : "Einloggen"}
          </button>
        </form>
        <p className="mt-6 font-mono-acc text-[10px] text-[#525252]">
          // Nur für die Inhaberin der Seite.
        </p>
      </div>
    </main>
  );
}
